import { ActionTypes } from "../contants/action-type";

const initialState = {
    setting: {}
}

export const SettingReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.SELECTED_SETTING:
            return {...state, setting: payload};
        case ActionTypes.CONFIRM_EDIT_SETTING:
            return {...state, setting: payload};
        default:
            return state;
    }
}